import {
  Alert,
  AlertIcon,
  AlertTitle,
  ChakraProvider,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export function OrganizationLoadingFallback() {
  const { t } = useTranslation();

  return (
    <ChakraProvider>
      <Flex w="100vw" h="100vh" alignItems="center" justifyContent="center">
        <Alert status="loading" maxW={"container.sm"}>
          <AlertIcon />
          <AlertTitle>{t("login.identifying_organization")}</AlertTitle>
        </Alert>
      </Flex>
    </ChakraProvider>
  );
}
